// M26.5 Part 8 — maps every real capability/tool string used across
// Nexceo::Ai::WorkforceRegistry::ROLES and Nexceo::AiEmployee#allowed_tools
// to a named group. Anything not in this map falls into "Other" rather
// than being silently dropped.
const CAPABILITY_GROUP_MAP = {
  // Sales
  qualification: 'Sales',
  lead_scoring: 'Sales',
  negotiation: 'Sales',
  objection_handling: 'Sales',
  booking: 'Sales',
  requirement_collection: 'Sales',
  project_comparison: 'Sales',
  project_discovery: 'Sales',
  comparison: 'Sales',
  greeting: 'Sales',
  handoff: 'Sales',
  // Project
  inventory: 'Project',
  pricing_overview: 'Project',
  availability: 'Project',
  project_qa: 'Project',
  check_inventory: 'Project',
  // Documentation
  brochure: 'Documentation',
  floor_plan: 'Documentation',
  walkthrough_video: 'Documentation',
  document_sharing: 'Documentation',
  share_document: 'Documentation',
  generate_comparison: 'Documentation',
  // Scheduling
  site_visit_scheduling: 'Scheduling',
  video_call_scheduling: 'Scheduling',
  reminders: 'Scheduling',
  rescheduling: 'Scheduling',
  schedule_site_visit: 'Scheduling',
  // CRM
  lead_management: 'CRM',
  kanban_updates: 'CRM',
  contact_sync: 'CRM',
  update_lead: 'CRM',
  move_stage: 'CRM',
  mark_junk: 'CRM',
  assign_agent: 'CRM',
  // Finance
  pricing: 'Finance',
  payment_plan: 'Finance',
  loan_query: 'Finance',
  emi: 'Finance',
  investment: 'Finance',
  // Legal
  rera: 'Legal',
  legal_docs: 'Legal',
  registration: 'Legal',
  compliance: 'Legal',
  // Marketing
  sales_story: 'Marketing',
  lifestyle_narrative: 'Marketing',
  // Support
  faq: 'Support',
  general_queries: 'Support',
  post_booking_support: 'Support',
  // Internal
  staff_queries: 'Internal',
  lead_reports: 'Internal',
  project_knowledge_summary: 'Internal',
  // Operations (generic AI-control tools)
  notify_agent: 'Operations',
  add_private_note: 'Operations',
  pause_ai: 'Operations',
  resume_ai: 'Operations',
};

// Fixed display order — groups appear in this sequence when present, so the
// same group always lands in the same place across cards.
const GROUP_ORDER = [
  'Sales',
  'Project',
  'Documentation',
  'Scheduling',
  'CRM',
  'Finance',
  'Legal',
  'Marketing',
  'Support',
  'Internal',
  'Operations',
  'Other',
];

export function groupCapabilities(capabilities) {
  const buckets = {};
  (capabilities || []).forEach(cap => {
    const group = CAPABILITY_GROUP_MAP[cap] || 'Other';
    if (!buckets[group]) buckets[group] = [];
    buckets[group].push(cap);
  });

  return GROUP_ORDER.filter(group => buckets[group]?.length).map(group => ({
    label: group,
    items: buckets[group],
  }));
}
